import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-about-single-page',
  templateUrl: './about-single-page.component.html',
  styleUrls: ['./about-single-page.component.css']
})
export class SigleAboutUSPage implements OnInit {

  timelineData = [
    { date: '2018', title: 'Opened the First Medical Center', description: 'Marked the start of our healthcare journey in Colombo.' },
    { date: '2019', title: 'Regional Expansion', description: 'Expanded to 14+ Medical Centers across South and Southeast Asia.' },
    { date: '2020', title: 'Global COVID-19 Operations', description: 'Launched COVID-19 testing and onboarded 60+ corporate clients.' },
    { date: '2021', title: 'Extended COVID-19 Programs', description: 'Expanded vaccination programs and teleconsultation services.' },
    { date: '2022', title: 'Healthcare Support for FIFA World Cup', description: 'Introduced diagnostic and radiology services for global events.' },
    { date: '2023', title: 'Oncology and AI Diagnosis', description: 'Expanded oncology services and entered AI-assisted diagnosis.' },
    { date: '2024', title: 'Soul Space and Mental Health Programs', description: 'Launched AI-powered mental health programs.' }
  ];
@Input() data:any;

  constructor() { }

  ngOnInit(): void {
  }

  selectedIndex: number | null = null;

  toggleContent(index: number): void {
    this.selectedIndex = this.selectedIndex === index ? null : index;
  }

}